define('collections/Podio.Collections.Spaces',['require','lib/backbone/Backbone.PodioCollection','underscore','models/Podio.Models.Space'],function(require) {

  var PodioCollection = require('lib/backbone/Backbone.PodioCollection');
  var _ = require('underscore');

  return PodioCollection.extend({

    initialize: function(models, options) {
      this._super();

      this.options = options || {};
      _.defaults(this.options, {
        org_id: void 0
      });

      if (_.isDefined(this.options.org_id)) {
        this.useDirectAPIAccess = true;
        this.urlAPI = '/org/{0}/space/'.format(this.options.org_id);
      }
    },

    configure: function() {
      this.model = require('models/Podio.Models.Space');
    }

  });

});

